import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { FunderConfig } from 'src/entity/customization';

@Injectable({
  providedIn: 'root'
})
export class CustomizationStoreService {
  //Get and save customization info in customizationData Observable
  private funderConfig = new BehaviorSubject<{}>({});
  public funderConfig$: Observable<{}> = this.funderConfig.asObservable();

  private funderStyles = new BehaviorSubject<{}>({});
  public funderStyles$: Observable<{}> = this.funderStyles.asObservable();

  private userID = new BehaviorSubject<{}>({});
  public userID$: Observable<{}> = this.userID.asObservable();

  private packID = new BehaviorSubject<{}>({});
  public packID$: Observable<{}> = this.packID.asObservable();

  private funderID = new BehaviorSubject<{}>({});
  public funderID$: Observable<{}> = this.funderID.asObservable();

  public policyTranslated = new BehaviorSubject<{}>({});
  public policyTranslated$: Observable<{}> = this.policyTranslated.asObservable();

  public termsTranslated = new BehaviorSubject<{}>({});
  public termsTranslated$: Observable<{}> = this.termsTranslated.asObservable();


  public lang$ = new BehaviorSubject<string>('es');

  public USER_ID;
  public PACK_ID;
  public FUNDER_CONFIG;
  public FUNDER_STYLES;
  public FUNDER_ID;
  public LANG;

  constructor() { }

  setLang(lang: string) {
    this.LANG = lang;
    this.lang$.next(lang);
  }

  setUserID(value: string) {
    this.USER_ID = value;
    this.userID.next(value);
  }

  setPackID(value: string) {
    this.PACK_ID = value;
    this.packID.next(value);
  }

  setFunderStyles(value) {
    this.FUNDER_STYLES = value;
    this.funderStyles.next(value);
  }

  setFunderConfig(value: FunderConfig) {
    this.FUNDER_CONFIG = value;
    this.funderConfig.next(value);
  }

  setFunderID(value: string) {
    this.FUNDER_ID = value;
    this.funderID.next(value);
  }

  setPolicy(value: string) {
    this.policyTranslated.next(value);
  }

  setTerms(value: string) {
    this.termsTranslated.next(value);
  }

  getUserID() {
    return this.userID$;
  }

  getPackID() {
    return this.packID$;
  }

  getPolicyTranslated() {
    return this.policyTranslated$;
  }

   getTermsTranslated() {
    return this.termsTranslated$;
  }

  getFunderConfig() {
    return this.funderConfig$;
  }

  getFunderStyles() {
    return this.funderStyles$;
  }

  getFunderID() {
    return this.funderID$;
  }

  getLang() {
    return this.lang$;
  }
}
